const MakevoraPopup = {
  goal: 49,

  show() {
    const popup = document.getElementById("makevora-popup");
    if (!popup) return;

    popup.classList.add("mv-show");

    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      popup.classList.remove("mv-show");
    }, 4000);
  },

  hide() {
    const popup = document.getElementById("makevora-popup");
    if (popup) popup.classList.remove("mv-show");
  },

  update(total) {
    const missing = Math.max(0, this.goal - total);

    const title = document.querySelector(".mv-title");
    const text = document.querySelector(".mv-text");
    const amount = document.querySelector(".mv-amount");
    const bar = document.querySelector(".mv-progress-bar");

    if (!title || !text || !amount || !bar) return;

    const progress = Math.min((total / this.goal) * 100, 100);
    bar.style.width = progress + "%";

    amount.textContent =
      total.toFixed(2).replace(".", ",") +
      " € / " +
      this.goal.toFixed(2).replace(".", ",") +
      " €";

    if (missing <= 0) {
      title.textContent = "Spedizione gratuita attivata";
      text.innerHTML =
        "Il tuo ordine beneficia della spedizione gratuita.";
    } else if (missing < 10) {
      title.textContent = "Sei quasi arrivato";
      text.innerHTML =
        "Aggiungi ancora <strong>" +
        missing.toFixed(2).replace(".", ",") +
        " €</strong> per ottenere la spedizione gratuita.";
    } else {
      title.textContent = "Spedizione gratuita";
      text.innerHTML =
        "Ti mancano <strong>" +
        missing.toFixed(2).replace(".", ",") +
        " €</strong> per ottenere la spedizione gratuita.";
    }

    this.show();
  }
};

window.MakevoraPopup = MakevoraPopup;